export default {
  "m0": "Caricamento dei dati personali...",
  "m1": "Si prega di controllare i campi evidenziati.",
  "m2": "La tua email di iscrizione è collegata al tuo account socio sicuro e non può essere cambiata qui. Contatta il club se ha bisogno di correggere.",
  "m3": "Per l'uso di emergenza da parte del personale autorizzato del club.",
  "m4": "Aggiungi un membro della famiglia",
  "m5": "Cerca un socio attivo e invia una richiesta di relazione.",
  "m6": "socio selezionato",
  "m7": "La famiglia attuale",
  "m8": "Nessun membro della famiglia collegato",
  "m9": "Aggiungi un membro sopra per avviare una richiesta di connessione familiare.",
  "m10": "Richieste in arrivo",
  "m11": "Richieste in uscita",
  "m12": "Gestisci i veicoli associati alla tua appartenenza.",
  "m13": "Questa sezione vi permetterà di:",
  "m14": "Mantenere i livelli aggiornati per i migliori giochi, abbinamenti e raccomandazioni.",
  "m15": "Inserisci l'handicap esatto",
  "m16": "Useremo questi livelli per migliorare i giochi adatti, abbinamenti e raccomandazioni.",
  "m17": "Impostare un livello sopra per iniziare il tuo profilo sportivo.",
  "m18": "Modifica foto",
  "m19": "Ritratto dal vivo",
  "m20": "socio",
  "m21": "Il vostro ritratto è in fase di preparazione e apparirà qui automaticamente.",
  "m22": "Le immagini vengono memorizzate in modo sicuro e sincronizzate con il profilo del portale del club.",
  "m23": "Torna a mangiare",
  "m24": "Privana pranzo",
  "m25": "Prenotazioni gastronomiche",
  "m26": "Accoglienza premurosa, riservata a voi.",
  "m27": "I tempi mostrati nel fuso orario del vostro club",
  "m28": "Privana Ceneri",
  "m29": "Organizza la tua visita",
  "m30": "Trova un tavolo",
  "m31": "Modifica",
  "m32": "Le aree pranzo stanno caricando...",
  "m33": "Le prenotazioni per i pasti non sono attualmente disponibili.",
  "m34": "Tempo di riferimento · facoltativo",
  "m35": "Ogni volta",
  "m36": "Trovare i tavoli...",
  "m37": "Il tuo tavolo aspetta",
  "m38": "Orari disponibili",
  "m39": "Recensione della tua prenotazione",
  "m40": "Note e richieste speciali",
  "m41": "Per gravi allergie, si prega di contattare direttamente il club in modo che la squadra di pranzo può aiutare in modo sicuro.",
  "m42": "I tuoi piani",
  "m43": "Il tuo prossimo tavolo è in attesa.",
  "m44": "Scegli una zona pranzo e scopri un tempo disponibile.",
  "m45": "Fai una prenotazione",
  "m46": "Le prenotazioni sono temporaneamente non disponibili.",
  "m47": "Storia della prenotazione",
  "m48": "Le prenotazioni dei pasti precedenti appariranno qui.",
  "m49": "Politica di cancellazione",
  "m50": "Annulla prenotazione",
  "m51": "Annullare la prenotazione?",
  "m52": "Questo rilascia il tavolo ed è soggetto alla finestra di cancellazione del club. Questa azione non può essere annullata.",
  "m53": "Tenere la prenotazione",
  "m54": "LET’s PLAY",
  "m55": "Cosa stiamo giocando?",
  "m56": "Non potevamo caricare Let’s Play in questo momento.",
  "m57": "Nessun sport è attualmente disponibile per Let’s Play in questo club.",
  "m58": "Mostrare sport al club salvati.",
  "m59": "Visualizza la storia",
  "m60": "Sport del club",
  "m61": "Non sono disponibili campi da golf attivi.",
  "m62": "Golf · Gioco",
  "m63": "Non abbiamo potuto caricare i tees di punteggio. Controllare la vostra connessione o firmare di nuovo, poi riprovare.",
  "m64": "Riprova a caricare i tee",
  "m65": "Tees",
  "m66": "Questo corso non è ancora pronto per Let’s Play.",
  "m67": "Il club ha bisogno di configurare i suoi tees di punteggio prima che un round possa essere avviato.",
  "m68": "Scegli i giocatori",
  "m69": "Golf · Giocatori",
  "m70": "I giocatori da completato Let's Play Golf round apparirà qui.",
  "m71": "Tondo di revisione",
  "m72": "Proseguite il giro",
  "m73": "Non ho potuto caricare i tuoi giri attivi.",
  "m74": "buche completati",
  "m75": "Elimina questo round?",
  "m76": "Non siamo riusciti a eliminare questo round.",
  "m77": "Attività non disponibile"
}
